import * as tslib_1 from "tslib";
import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '../../../ErrorBoundary';
var WixPortfolioModal = lazy(function () {
    return import(
    /* webpackChunkName: "wixportfoliomobilemodal" */
    './WixPortfolioMobileModal.container');
});
var LoadableWixPortfolioMobileModal = function (props) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Suspense, { fallback: null },
            React.createElement(WixPortfolioModal, tslib_1.__assign({}, props)))));
};
LoadableWixPortfolioMobileModal.displayName = 'LoadableWixPortfolioMobileModal';
export default LoadableWixPortfolioMobileModal;
//# sourceMappingURL=LoadableWixPortfolioMobileModal.js.map